import React from 'react';
import UWSection from 'modules/cm/components/UWSection/UWSection';
import UWGrid from 'modules/cm/components/UWGrid/UWGrid';
import UWTable from 'modules/cm/components/UWTable/UWTable';
import {
  mapGeneralToViewModel,
  mapMortgagePropertyToViewModel,
  mapLoanToViewModel,
  mapBorrower,
} from './viewModel/mappers';
import { SUBDOMAINS } from 'modules/cm/domain/PepperUploadPreview/PepperUploadPreview';
import useCurrentCaseStore from 'modules/cm/hooks/useCurrentCaseStore';

const PepperUploadPreviewSummary = () => {
  const data = useCurrentCaseStore().pepperReview;
  return (
    <UWGrid>
      <UWSection title="General">
        <UWTable titles={[]} rows={mapGeneralToViewModel(data[SUBDOMAINS.GENERAL])} />
      </UWSection>
      <UWSection title="Loan">
        <UWTable titles={[]} rows={mapLoanToViewModel(data[SUBDOMAINS.LOAN])} />
      </UWSection>
      <UWSection title="Borrower(s)">
        <UWTable titles={['', 'Applicant 1', 'Applicant 2']} rows={mapBorrower(data[SUBDOMAINS.BORROWER])} />
      </UWSection>
      <UWSection title="Mortgaged Property">
        <UWTable titles={[]} rows={mapMortgagePropertyToViewModel(data[SUBDOMAINS.MORTGAGE_PROPERTY])} />
      </UWSection>
    </UWGrid>
  );
};

export default PepperUploadPreviewSummary;
